import { url } from '@exodus/fetch/url';
const SERVER = new URL('https://api.n.exchange/en/api/v1/orders');
const getNexchangeOrder = async (id, fetchival) => {
    return fetchival(url `${SERVER}/${id}/`).get();
};
const getProviderOrder = async (providerOrder, fetchival) => {
    const orderInfo = await getNexchangeOrder(providerOrder.id, fetchival);
    return {
        orderId: providerOrder.id,
        depositAddress: orderInfo.deposit_address.address,
        depositAmount: orderInfo.amount_quote,
        withdrawalAddress: orderInfo.withdraw_address.address,
    };
};
const nexchangeConfig = {
    ne: getProviderOrder,
};
export default nexchangeConfig;
